import { render } from "./TenantLogin.vue?vue&type=template&id=661ff516&scoped=true"
import script from "./TenantLogin.vue?vue&type=script&lang=js"
export * from "./TenantLogin.vue?vue&type=script&lang=js"

import "./TenantLogin.vue?vue&type=style&index=0&id=661ff516&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661ff516"]])

export default __exports__